export default __webpack_public_path__ + "assets/c7272ec949a913ee1c154555448015ee/04.jpg";